import { AnnouncementCategory, AnnouncementLevel } from '../../components/announcements/common';

// =============================================================================
// 1. LANDING PAGE/App entry
// =============================================================================
export const NAVIGATE_TO_PARAMS = 'Navigate to Params';
export const NAVIGATE_TO_SEATING = 'Navigate to Seating';

// =============================================================================
// 2. PARAMETER/FILTERS PAGE
// =============================================================================
export const FILTER_CHANGED = 'Filter Change';
export const FILTER_VIEWED = 'Filter Viewed';
export const SHOW_RESULTS = 'Show Results';
export const OPEN_PARAMETERS_SEARCH_BLOCKED = 'Open Parameters Search Blocked';
export const OPEN_PARAMETERS_CLEARED = 'Open Parameters Cleared';
export const LEAD_GEN_PARTY_SIZE_SELECTED = 'Lead Gen Party Size Selected';
export const OPEN_PARAMETERS_NO_AVAILABILITY = 'Open Parameters No Availability';


// =============================================================================
// 3. EXPLORE PAGE (Inventory Carousel)
// =============================================================================
export const PAGE_SCROLLED_TO_BOTTOM = 'Page Scrolled To Bottom';
export const CAROUSEL_RESULTS_LOADED = 'Carousel Results Loaded';
export const TABLE_CLICKED_FROM_CAROUSEL = 'Table Clicked From Carousel';
export const RESULT_CLICKED = 'Result Clicked';
export const RESULT_VIEWED = 'Result Viewed';
export const TOP_BAR_FILTER_PARAMETER_CLICKED = 'Top Bar Filter Parameter Clicked';
export const PROCEED_TO_CHECKOUT_CLICKED = 'Proceed to Checkout clicked';

// =============================================================================
// MATTERPORT 3D ENVIRONMENT
// =============================================================================
export const MP_OVERLAY_DISMISSED = 'Matterport Overlay Dismissed';
export const MP_TAG_CLICKED = 'Matterport Tag Clicked';
export const MATTERPORT_LINK_CLICKED = 'Matterport Link Clicked';
export const VIEW_TOGGLED = 'View Toggled';
export const CONFIRM_RESERVATION = 'Confirm Reservation';

// =============================================================================
// 4. CONFIRMATION
// =============================================================================
export const BOOKING_CONFIRMATION_FAILED = 'Booking confirmation failed';
export const BOOKING_CONFIRMATION_TIMEOUT = 'Booking confirmation timeout';

// =============================================================================
// ERROR HANDLING
// =============================================================================
export const PROCEED_TO_PAYMENT_FAILED = 'Proceed to payment failed';
export const RESOURCE_NOT_FOUND = 'Resource Not Found';
export const UNEXPECTED_ERROR = 'Unexpected Error';

// =============================================================================
// ANNOUNCEMENTS & NOTIFICATIONS
// =============================================================================
export const CLOSE_GLOBAL_BANNER = 'Global Announcement Banner Closed';
export const MARKETING_ANNOUNCEMENT_VIEWED = 'Marketing Announcement Viewed';

// =============================================================================
// ECOMMERCE
// =============================================================================
export const ECOMMERCE_SECTION_VIEWED = 'Ecommerce Section Viewed';

// =============================================================================
// GENERAL UI INTERACTIONS
// =============================================================================
export const LOADED_A_PAGE = 'Loaded a Page';
export const LINK_CLICKED_EVENT = 'Link Clicked';
export const PAGE_EXITED_EVENT = 'Page Exited';
export const INFO_CLICKED_EVENT = 'Info Clicked';
export const MODAL_OPENED_EVENT = 'Modal Opened';
export const MODAL_CLOSED_EVENT = 'Modal Closed';
export const CTA_CLICKED_EVENT = 'CTA Clicked';

export const REDIRECT_TO_RMS_FROM_ASSIGNED_SEATING_CARD = 'Redirect to RMS from Assigned Seating Card';

// =============================================================================
// MEDIA INTERACTIONS
// =============================================================================
export const MEDIA_360_VIEW_HOVER = 'Media 360 View Hover';
export const MEDIA_360_VIEW_LONG_PRESS = 'Media 360 View Long Press';
export const MEDIA_CAROUSEL_SWIPE = 'Media Carousel Swipe';
export const MEDIA_CAROUSEL_DOT_CLICK = 'Media Carousel Dot Click';
export const MEDIA_CAROUSEL_NAV_CLICK = 'Media Carousel Navigation Click';
export const MEDIA_ITEM_VIEWED = 'Media Item Viewed';

// =============================================================================
// INTERFACES & TYPES
// =============================================================================
export interface AnnouncementEvent {
	location: 'Inventory Carousel' | 'Table Drawer',
	level: AnnouncementLevel
	message: string,
	type: AnnouncementCategory
	tableId?: string
}

// =============================================================================
// STATSIG EVENTS — whitelist of events forwarded to Statsig.
// Built from the canonical event-name constants above so names can never drift.
// =============================================================================
export const STATSIG_EVENTS = {
	LOADED_A_PAGE,
	PAGE_EXITED: PAGE_EXITED_EVENT,
	LINK_CLICKED: LINK_CLICKED_EVENT,
	SHOW_RESULTS,
	FILTER_CHANGED,
	FILTER_VIEWED,
	OPEN_PARAMETERS_SEARCH_BLOCKED,
	OPEN_PARAMETERS_CLEARED,
	LEAD_GEN_PARTY_SIZE_SELECTED,
	OPEN_PARAMETERS_NO_AVAILABILITY,
	PAGE_SCROLLED_TO_BOTTOM,
	CAROUSEL_RESULTS_LOADED,
	RESULT_VIEWED,
	RESULT_CLICKED,
	TOP_BAR_FILTER_PARAMETER_CLICKED,
	TABLE_CLICKED_FROM_CAROUSEL,
	MATTERPORT_TAG_CLICKED: MP_TAG_CLICKED,
	MATTERPORT_LINK_CLICKED,
	VIEW_TOGGLED,
	CONFIRM_RESERVATION,
	PROCEED_TO_CHECKOUT_CLICKED,
	INFO_CLICKED: INFO_CLICKED_EVENT,
	CTA_CLICKED: CTA_CLICKED_EVENT,
	ECOMMERCE_SECTION_VIEWED,
	NAVIGATE_TO_PARAMS
} as const;

